import { createContext } from "react";
import { useInformeFaturamento } from "../hooks/useInformeFaturamento";
import { ILinhaInformeFaturamentoValidada } from "../interfaces/ILinhaInformeFaturamento";

interface IContext {
  arquivo: File | null;
  setArquivo(arquivo: File | null): void;
  numeroCarta: string;
  linhas: ILinhaInformeFaturamentoValidada[];
  loading: boolean;
  importar(): void;
  salvar(): void;
}

export const InformeFaturamentoContext = createContext<IContext>({
  arquivo: null,
  setArquivo: () => {},
  numeroCarta: "",
  linhas: [],
  loading: false,
  importar: () => {},
  salvar: () => {},
});

interface Props {
  children: React.ReactNode;
}

export function InformeFaturamentoProvider({ children }: Props) {
  const { arquivo, setArquivo, numeroCarta, linhas, loading, importar, salvar } =
    useInformeFaturamento();

  return (
    <InformeFaturamentoContext.Provider
      value={{
        arquivo,
        setArquivo,
        numeroCarta,
        linhas,
        loading,
        importar,
        salvar,
      }}
    >
      {children}
    </InformeFaturamentoContext.Provider>
  );
}
